export default __webpack_public_path__ + "static/girl1-396ebedcee0077da150eafb093b475e4.svg";